import React from 'react'

import homePageStyle from '../../styles/components/homePage/home_page'
import plainCard from '../../styles/components/homePage/plain_card'
import Title from '../HomePage/Title'
import Card from './Card'

const TopStories = ({ collection = [] }) => {
  return (
    <div className='top-stories-list'>
      <Title title='Top Stories' />
      {collection.map(story => (
        <Card key={story.slug} style={plainCard} story={story} />
      ))}
      <style jsx>{homePageStyle}</style>
    </div>
  )
}

export default TopStories
